<script>
import AIContentTrainingBox from '@app/components/AIContentTrainingBox.vue';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    summary: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      bundle: {
        name: this.name,
        summary: this.summary,
      },
    };
  },
  mounted() {
    this.$refs.nameInput.focus();
  },
  methods: {
    showAIContentGenerator(type) {
      this.$buefy.modal.open({
        parent: this,
        canCancel: false,
        component: AIContentTrainingBox,
        width: 640,
        hasModalCard: true,
        props: { type },
      });
    },
    handle() {
      this.isLoading = true;
      this.$store.dispatch('bundles/add', { ...this.bundle })
        .then((data) => {
          this.$router.push({ name: 'bundle', params: { uuid: data.uuid } });
          this.$emit('close');
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <form class="modal-card" @submit.prevent="dataIsValid(isLoading) && handle()">
    <header class="modal-card-head">
      <h2 class="modal-card-title">
        Ajouter un pack
      </h2>
      <button type="button" class="modal-close is-large" aria-label="Fermer" @click="$emit('close')" />
    </header>
    <div class="modal-card-body">
      <div class="columns is-multiline">
        <div class="column is-12 pb-0">
          <b-field label-for="bundle-name">
            <template #label>
              <span class="flex-between-center">
                Titre

                <b-tooltip
                  v-if="!$store.getters['auth/hasEnterpriseCapabilities']"
                  label="En panne d'inspiration pour le titre de votre pack ? Faites appel à notre Copywriter IA"
                  position="is-left"
                  multilined
                >
                  <a
                    class="has-text-weight-normal is-size-8"
                    @click="showAIContentGenerator('title_ideas')"
                  >
                    <b-icon icon="magic" size="is-small" />
                    Générer
                  </a>
                </b-tooltip>
              </span>
            </template>
            <b-input
              id="bundle-name"
              ref="nameInput"
              v-model="bundle.name"
              required
              maxlength="128"
            />
          </b-field>
        </div>
        <div class="column is-12 pt-0">
          <b-field label-for="bundle-summary">
            <template #label>
              <span class="flex-between-center">
                Description courte

                <b-tooltip
                  v-if="!$store.getters['auth/hasEnterpriseCapabilities']"
                  label="En panne d’inspiration pour la description de votre pack ? Laissez notre assistant Copywriter IA vous proposer des formulations claires, attractives et prêtes à convertir"
                  position="is-left"
                  multilined
                >
                  <a
                    class="has-text-weight-normal is-size-8"
                    @click="showAIContentGenerator('value_proposition')"
                  >
                    <b-icon icon="magic" size="is-small" />
                    Générer
                  </a>
                </b-tooltip>
              </span>
            </template>
            <b-input
              id="bundle-summary"
              v-model="bundle.summary"
              type="textarea"
              maxlength="200"
            />
          </b-field>
        </div>
      </div>
    </div>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <div class="buttons">
        <b-button type="is-text" @click="$emit('close')">
          Fermer
        </b-button>
        <b-button type="is-primary" native-type="submit" :loading="isLoading">
          Ajouter
        </b-button>
      </div>
    </footer>
  </form>
</template>
